module.exports = __webpack_public_path__ + "img/tpc-printable-flyers-2.ff72f610.jpg";